'use client';

import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { FormField } from '../form/FormField';
import { RadioGroup, RadioGroupItem } from '../form/input/RadioGroup';
import { Typography } from '../typography/Typography';
import { Map as MapComponent } from './map-lazy';

export type PointOfInterestProps = {
  name?: string;
  address?: string;
  longitude?: number;
  latitude?: number;
  distance?: string;
}

type PointOfInterestMapProps = {
  location: {
    lon: number;
    lat: number;
  }
  pointOfInterests?: Array<{
    name?: string;
    items?: PointOfInterestProps[];
  }>
  listTitle: string;
  accessToken: string;
  /**
   * The text to display for the radio buttons to hide the points of interest
   */
  hidePoints: string;
  zoomText?: {
    ctrlMessage: string;
    cmdMessage: string;
    zoomIn: string;
    zoomOut: string;
    touchPan: string;
  }
}

export const PointOfInterestMap = ({
  location,
  pointOfInterests,
  accessToken,
  listTitle,
  hidePoints,
  zoomText,
}: PointOfInterestMapProps) => {

  const {
    control,
    setValue,
  } = useForm();

  const [selectedInterest, setSelectedInterest] = useState<string | undefined>(undefined);

  const pointOfInterestsList = pointOfInterests
    ?.filter((item) => item.name === selectedInterest).map((item) => item.items)
    .flat()
    .filter(Boolean)
    ?.map((item) => ({
      id: item?.name ?? '',
      longitude: item?.longitude ?? 0,
      latitude: item?.latitude ?? 0,
      extraPoiProperties: {
        name: item?.name ?? '',
        address: item?.address ?? '',
        distance: item?.distance ?? '',
      },
    }));

  return (
    <div>
      <div className="mb-4 h-[20em] w-full md:h-[25em]">
        <MapComponent
          location={location}
          locationList={pointOfInterestsList}
          renderMarkersAs="pointOfInterest"
          accessToken={accessToken}
          zoomText={zoomText}
          defaultLocation={
            {
              longitude: 4.46280533777813,
              latitude: 51.9151761415949,
            }
          }
        />
      </div>
      {pointOfInterests ? (
        <div>
          <Typography
            variant="title-body"
            className="mb-4"
            textColorClassname="text-title-body-desktop"
          >
            {listTitle}
          </Typography>
          <FormField
            render={() => (
              <RadioGroup
                defaultValue={hidePoints}
              >
                <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
                  {pointOfInterests.map((interest) => {
                    return (
                      (interest.name && (
                        <RadioGroupItem
                          key={interest.name}
                          label={interest.name}
                          value={interest.name}
                          onClick={() => setSelectedInterest(interest.name)}
                        />
                      ))
                    );
                  })}
                  <RadioGroupItem
                    label={hidePoints}
                    value={hidePoints}
                    onClick={() => setSelectedInterest(undefined)}
                  />
                </div>
              </RadioGroup>
            )}
            control={control}
            name="poiList"
            setValue={setValue}
          />
        </div>
      ) : null}
    </div>
  );
};
